// GLAMI voucher configuration data
// Keys are uppercase to match the `glamivoucher` URL parameter after normalization.
// Only list active GLAMI campaign codes here — GLAMI publishes these publicly,
// so storing them in the theme is not a leak of private discount codes.
window.glamiConfig = {
  "GLAMI30": {
    percentage: 30,
    campaignName: "GLAMI"
  }
};
